(() => {
  const mount = () => {
    if (document.getElementById('VvherbLocalizationForm')) return;

    const style = document.createElement('style');
    style.id = 'VvherbLocalizationStyle';
    style.textContent = `
      .vvherb-localization { position: fixed; z-index: 2147483000; right: max(1rem, env(safe-area-inset-right)); bottom: max(1rem, env(safe-area-inset-bottom)); width: min(18rem, calc(100vw - 2rem)); border: 1px solid rgba(0, 0, 0, 0.18); border-radius: 6px; background: #ffffff; color: #141414; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12); font: inherit; }
      .vvherb-localization summary { cursor: pointer; padding: 0.65rem 0.8rem; font-weight: 600; list-style: none; }
      .vvherb-localization summary::-webkit-details-marker { display: none; }
      .vvherb-localization form { display: grid; gap: 0.45rem; padding: 0 0.8rem 0.8rem; }
      .vvherb-localization label { font-size: 0.8rem; font-weight: 600; }
      .vvherb-localization select, .vvherb-localization button { min-height: 2.5rem; width: 100%; border: 1px solid rgba(0, 0, 0, 0.28); border-radius: 4px; background: #ffffff; color: inherit; font: inherit; }
      .vvherb-localization button { cursor: pointer; border-color: #141414; background: #141414; color: #ffffff; }
    `;
    document.head.appendChild(style);

    const root = document.createElement('div');
    root.id = 'VvherbLocalizationRoot';
    root.innerHTML = `
      <details class="vvherb-localization" data-vvherb-localization>
        <summary data-vvherb-region-label>Region &amp; currency</summary>
        <form action="/localization" method="post" id="VvherbLocalizationForm">
          <input name="_method" type="hidden" value="put">
          <input name="return_to" type="hidden" value="/">
          <label for="VvherbLocalizationCountry" data-vvherb-country-label>Country &amp; currency</label>
          <select id="VvherbLocalizationCountry" name="country_code">
            <option value="PT">Portugal (EUR)</option>
            <option value="US">United States (USD)</option>
            <option value="GB">United Kingdom (GBP)</option>
            <option value="CA">Canada (CAD)</option>
            <option value="AU">Australia (AUD)</option>
          </select>
          <label for="VvherbLocalizationLanguage" data-vvherb-language-label>Language</label>
          <select id="VvherbLocalizationLanguage" name="language_code">
            <option value="pt-PT">Portugues</option>
            <option value="en">English</option>
          </select>
          <button type="submit" data-vvherb-update-label>Update</button>
        </form>
      </details>
    `;
    document.body.appendChild(root);

    const shopify = window.Shopify || {};
    const currentCountry = shopify.country || 'PT';
    const currentLanguage = shopify.locale || 'pt-PT';
    const targetCountries = new Set(['US', 'GB', 'CA', 'AU']);
    const sessionKey = 'vvherb.localization.autodetected.v1';
    const form = document.getElementById('VvherbLocalizationForm');
    const countrySelect = document.getElementById('VvherbLocalizationCountry');
    const languageSelect = document.getElementById('VvherbLocalizationLanguage');
    if (!form || !countrySelect || !languageSelect) return;

    if ([...countrySelect.options].some((option) => option.value === currentCountry)) {
      countrySelect.value = currentCountry;
    }
    if ([...languageSelect.options].some((option) => option.value === currentLanguage)) {
      languageSelect.value = currentLanguage;
    }
    if (currentLanguage === 'pt-PT') {
      root.querySelector('[data-vvherb-region-label]').textContent = 'Regiao e moeda';
      root.querySelector('[data-vvherb-country-label]').textContent = 'Pais e moeda';
      root.querySelector('[data-vvherb-language-label]').textContent = 'Idioma';
      root.querySelector('[data-vvherb-update-label]').textContent = 'Atualizar';
    }

    form.addEventListener('submit', () => {
      try { window.sessionStorage.setItem(sessionKey, 'manual'); } catch (_) {}
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) {
        returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      }
    });

    const remembered = () => {
      try { return window.sessionStorage.getItem(sessionKey); } catch (_) { return null; }
    };
    const remember = (value) => {
      try { window.sessionStorage.setItem(sessionKey, value); } catch (_) {}
    };
    const applyLocalization = (country) => {
      const updateForm = document.createElement('form');
      updateForm.action = '/localization';
      updateForm.method = 'post';
      updateForm.hidden = true;
      const values = {
        _method: 'PUT',
        country_code: country,
        language_code: 'en',
        return_to: window.location.pathname + window.location.search + window.location.hash,
      };
      Object.entries(values).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = value;
        updateForm.appendChild(input);
      });
      document.body.appendChild(updateForm);
      updateForm.submit();
    };
    if (remembered()) return;

    if (targetCountries.has(currentCountry) && currentLanguage !== 'en') {
      remember(`${currentCountry}:en`);
      applyLocalization(currentCountry);
      return;
    }

    const storefrontRoot = (shopify.routes && shopify.routes.root) || '/';
    const suggestionUrl = new URL(
      'browsing_context_suggestions.json',
      window.location.origin + storefrontRoot,
    );
    suggestionUrl.searchParams.set('country[enabled]', 'true');
    suggestionUrl.searchParams.set('country[exclude]', currentCountry);
    suggestionUrl.searchParams.set('language[enabled]', 'true');
    suggestionUrl.searchParams.set('language[exclude]', currentLanguage);

    window.fetch(suggestionUrl.toString(), { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        const suggestion = (payload && payload.suggestions || []).find((item) => {
          const country = item && item.parts && item.parts.country;
          return country && country.confidence >= 0.9 && targetCountries.has(country.handle);
        });
        const country = suggestion && suggestion.parts && suggestion.parts.country && suggestion.parts.country.handle;
        if (!country || (country === currentCountry && currentLanguage === 'en')) return;
        remember(`${country}:en`);
        applyLocalization(country);
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
